import { inject } from 'aurelia-framework';
import { Redirect } from 'aurelia-router';
import { AuthService } from 'services/authService';
import { Router } from 'aurelia-router';
import { HttpClient } from 'aurelia-http-client';

@inject(AuthService)
export class App {

  constructor(authService) {
    this.authService = authService;
    if (!String.prototype.includes) {
      String.prototype.includes = function () {
        'use strict';
        return String.prototype.indexOf.apply(this, arguments) !== -1;
      };
    }

    this.home_url = window.home_url;
    this.site_url = window.site_url;
    this.supportEmail = window.support_email;
    this.enable_plus = true;
    if(window.whitelabel) {
      this.whitelabel = window.whitelabel;
      this.footer_html = window.footer_html;
      this.logo_img = "api/whitelabel/getFile?file=site_logo";
      this.logo_alt = window.app_name + " Logo";
      this.tutorialUrl = window.tutorial_url;
      this.whitelabel_status = window.whitelabel_status;
      this.enable_plus = window.enable_plus;

    }

    this.whitelabelCss = null;


  }
whitelabel_resource_redirect(){
    console.log("redirect url " + window.resource_url);
    window.open(window.resource_url, "_blank");
}
  activate() {
    // if (this.whitelabel) {
      var http = new HttpClient();
      http.get('api/whitelabel/getFile?file=site_css')
        .then(data => {
          if (data.isSuccess)
            this.whitelabelCss = data.response;
        });
    // }
  }

  configureRouter(config, router) {
    this.router = router;
    config.title = window.whitelabel ? window.site_title : 'Magnfi | Video Testimonials Made Easy';
    var step = new AuthorizeStep(this.authService, this.whitelabel_status, this.enable_plus);
    config.addAuthorizeStep(step);
    config.addPipelineStep('postcomplete', PostCompleteStep);
    config.map([
      { route: ['', 'visitor'], name: 'visitor', activationStrategy: "replace", moduleId: 'visitor' },
      { route: ['user'], name: 'user', moduleId: 'user', settings: { auth: true } },
      { route: ['admin'], name: 'admin', moduleId: 'admin', view: 'user.html', settings: { auth: true, admin: true } },
      { route: ['wladmin'], name: 'wladmin', moduleId: 'wladmin', view: 'user.html', settings: { auth: true, wladmin: true } },
      { route: ['ytmanager'], name: 'ytmanager', moduleId: 'ytmanager', view: 'user.html', settings: { auth: true, ytmanager: true } },
      { route: ['capture'], name: 'capture', moduleId: 'capture' },
      { route: ['login'], name: 'login', moduleId: 'visitor', settings: { showLogin: true } },
      { route: ['contact'], name: 'contact', moduleId: 'visitor', settings: { showContact: true } },
      { route: ['email/:key'], name: 'email', moduleId: 'components/visitor/videoEmail'},
      { route: ['message/:key'], name: 'message', moduleId: 'components/visitor/videoMessage'},
      { route: ['print/admin/whiteLabelInvoice'], name: 'printWhiteLabelInvoice', moduleId: 'components/admin/print/whiteLabelInvoices', settings: { auth: true, admin: true } },
      { route: ['print/wladmin/whiteLabelInvoice'], name: 'printWhiteLabelInvoice', moduleId: 'components/wladmin/print/whiteLabelInvoices', settings: { auth: true, wladmin: true } },
    ]);
    config.mapUnknownRoutes({ redirect: '#/' });
  }
}

class PostCompleteStep {
  run(instruction, next) {
    if (!instruction.config.settings.noScrollToTop) {
      window.scrollTo(0, 0);
    }

    return next();
  }
}

class AuthorizeStep {
  constructor(authService, whitelabel_status, enable_plus) {
    this.authService = authService;
    this.whitelabel_status = whitelabel_status;
    this.enable_plus = enable_plus
  }
  run(navigationInstruction, next) {
    if (navigationInstruction.getAllInstructions().some(i => i.config.settings.auth)) {

      if (!this.authService.isLoggedIn()) {
        return next.cancel(new Redirect('#/login?url=' + navigationInstruction.fragment));
      } else {

        if (this.authService.getUser().role == 'USER') {

          if (parseInt(this.whitelabel_status) == 2) {
            if (!navigationInstruction.fragment.includes('user/suspended')) {
              return next.cancel(new Redirect('user/suspended'));
            }
          } else {

            if(!this.authService.getUser().agreements_checked) {
              if(!navigationInstruction.fragment.includes('user/agreements')) {
                return next.cancel(new Redirect('user/agreements'));
              }
            } else {


              if ((parseInt(this.authService.getAccount().status) == 0
                || parseInt(this.authService.getAccount().status) == 3 || this.authService.getSubError()) && !navigationInstruction.fragment.includes('user/subscription')
                && this.enable_plus){

                    return next.cancel(new Redirect('user/subscription'));
                }

              if((navigationInstruction.fragment.includes('user/video/caseStudy') ||
                  navigationInstruction.fragment.includes('user/video/email') ||
                  navigationInstruction.fragment.includes('user/video/message'))
                  && (!this.authService.getAccount().subscription_type || !(this.authService.getAccount().subscription_type.startsWith("PLUS") || this.authService.getAccount().subscription_type=="PREMIUM"))){
                  return next.cancel(new Redirect('user/subscription'));

                  }

              if (parseInt(this.authService.getAccount().status) == 2 && !this.authService.getAccount().logo_file && !navigationInstruction.fragment.includes('user/orgInfo') &&!navigationInstruction.fragment.includes('user/subscription'))
                return next.cancel(new Redirect('user/orgInfo'));


            }
          }

          if(!this.enable_plus || this.authService.getAccount().subscription_type == 'PLUSGRANTED') {
            if (navigationInstruction.fragment.includes('user/subscription')) {
              return next.cancel(new Redirect('user/home'));
            }
          }
        }

        if (parseInt(this.authService.getAccount().status) == 1 && !navigationInstruction.fragment.includes('user/confirm'))
           return next.cancel(new Redirect('user/confirm'));

        if (this.authService.getUser().role == 'WLADMIN') {


          if ((parseInt(this.whitelabel_status) > 0
            && parseInt(this.whitelabel_status) < 3) && !navigationInstruction.fragment.includes('wladmin/whitelabel'))
            return next.cancel(new Redirect('wladmin/whitelabel'));
          if (!this.authService.getAccount().logo_file && !navigationInstruction.fragment.includes('user/orgInfo'))
            return next.cancel(new Redirect('user/orgInfo'));

        }


      }
    }

    if (navigationInstruction.fragment.includes('user/purchase') && this.authService.getAccount().subscription_type && this.authService.getAccount().subscription_type.startsWith('PLUS'))
      return next.cancel(new Redirect('user/home'));

    if (navigationInstruction.getAllInstructions().some(i => i.config.settings.admin)) {
      if (!this.authService.isLoggedIn() || this.authService.getUser().role != 'ADMIN') {
        return next.cancel(new Redirect('user/home'));
      }
    }



    if (navigationInstruction.getAllInstructions().some(i => i.config.settings.wladmin)
      && (!this.authService.isLoggedIn() || this.authService.getUser().role != 'WLADMIN') ) {


        if(navigationInstruction.getAllInstructions().some(i => i.config.settings.wlmanager)) {

          if(!this.authService.isLoggedIn() || this.authService.getUser().role != 'WLMANAGER') {
            return next.cancel(new Redirect('user/home'));
          }
        } else
          return next.cancel(new Redirect('user/home'));



    }


    if (navigationInstruction.getAllInstructions().some(i => i.config.settings.ytmanager)
    && (!this.authService.isLoggedIn() || this.authService.getUser().role != 'YTMANAGER') ) {
        return next.cancel(new Redirect('user/home'));
    }



    if (navigationInstruction.getAllInstructions().some(i => i.config.settings.magnfiOnly)) {
      if (this.authService.isLoggedIn() && this.authService.getUser().whitelabel_id != null) {
        return next.cancel(new Redirect('user/home'));
      }
    }

    return next();
  }
}


